import { CheckoutCustomer } from "./CheckoutCustomer";

export default CheckoutCustomer;
